
import EoCallToAction from '../../EoCallToAction/EoCallToAction.vue'

export default {
  name: "PreprCallToAction",
  components: { EoCallToAction },
  props: {
    /**
     * Prepr data of this element
     */
    data: {
      type: Object,
      default: () => {},
    },
    /**
     * Prop and attribute overwrites
     */
    overwrites: {
      type: Object,
      default: () => {
        return {}
      },
    },
    /**
     * Index
     */
    index: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      // Prepr data model
      dataModel: {
        calltoaction: {
          items: [
            {
              id: null,
              items: {
                'nl-NL': null,
              },
              environment: {
                domain: null,
              },
              model: {
                id: null,
              },
            },
          ],
        },
      },
    }
  },
  computed: {
    normalizedData () {
      return {...this.dataModel.calltoaction.items[0], ...this.data.calltoaction?.items?.[0]}
    },
    target () {
      return this.to?.startsWith('http') ? '_blank' : '_self'
    },
    title () {
      return this.normalizedData.items['nl-NL'].title?.body
    },
    description () {
      return this.normalizedData.items['nl-NL'].description?.body
    },
    cta () {
      return this.normalizedData.items['nl-NL'].cta?.body
    },
    media () {
      return this.normalizedData.items['nl-NL'].media?.items?.[0]
    },
    mediaType () {
      return this.media?.label
    },
    mediaUrl () {
      return this.media?.cdn_files?.items?.[0]?.url
    },
    video () {
      if (!this.mediaUrl || this.mediaType !== 'Video') return
      return this.mediaUrl
    },
    image () {
      if (!this.mediaUrl || this.mediaType === 'Video') return
      return this.mediaUrl
    },
    imageSize () {
      return `xs:520x${(520 / this.media?.width) * this.media?.height} sm:300x380 md:580x386 lg:630x420`
    },
    imageWidth () {
      return 'xs:calc(100vw - 80px) sm:calc((100vw - 40px) * 0.35) md:calc((100vw - 40px) * 0.5) lg:630'
    },
    to () {
      if (!this.normalizedData) return null
      // Check if Call to action refers to a direct url
      if (this.normalizedData.items['nl-NL'].url?.body) {
        return this.normalizedData.items['nl-NL'].url.body
      }
      // Check if Call to action refers to a publication
      if (this.normalizedData.items['nl-NL'].reference?.items?.[0]) {
        return this.$link.publication(this.normalizedData.items['nl-NL'].reference.items[0])
      }
      return null
    },
    buttonColor () {
      if (!this.overwrites.color) return null
      const isDarkeningPossible = this.$color.step(this.overwrites.color, 2)
      return this.$color.step(this.overwrites.color, isDarkeningPossible ? 2 : -2)
    },
  },
}
